import { Draw } from '@/modules/draw/draws/types/Draw.ts'
import { DrawListResponse } from '@/modules/draw/draws/services/apiValidation/drawListApiValidation.ts'

export const drawsPage1: { data: DrawListResponse } = {
  data: {
    results: [
      {
        id: 1,
        name: 'Sorteo Semanal',
        description: 'Sorteo entre participantes activos.',
        selectionType: 'RANDOM',
        isActive: true,
        campaignId: '1',
        campaignName: 'Campaña de Verano'
      },
      {
        id: 2,
        name: 'Sorteo Fin de Año',
        description: 'Sorteo especial con criterios de selección.',
        selectionType: 'CRITERIA',
        isActive: false,
        campaignId: '2',
        campaignName: 'Campaña Navideña'
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  }
}

export const drawDetail: { data: Draw } = {
  data: drawsPage1.data.results[0]
}
